import { render, staticRenderFns } from "./VbgHealthCheckCard.vue?vue&type=template&id=1bd78730&scoped=true"
import script from "./VbgHealthCheckCard.vue?vue&type=script&lang=js"
export * from "./VbgHealthCheckCard.vue?vue&type=script&lang=js"
import style0 from "./VbgHealthCheckCard.vue?vue&type=style&index=0&id=1bd78730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd78730",
  null
  
)

export default component.exports